// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const UpIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Up",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.36 8.56c-.11.06-.21.12-.3.19s-.18.11-.18.11h-.08L2.66 20.46c-.4.32-.66.81-.66 1.36a1.741 1.741 0 0 0 3.05 1.15s10.96-10.43 10.96-10.43l10.95 10.43a1.741 1.741 0 1 0 2.4-2.51S17.22 8.89 17.22 8.89h-.08l-.18-.11c-.09-.08-.19-.15-.29-.22-.09-.03-.2-.06-.31-.07-.1-.03-.21-.05-.32-.06-.12 0-.23.03-.34.06h.01c-.12 0-.23.03-.33.07h.01Z"
    })
  });
};